import { z } from "zod";
import { metaSchema, sortBySchema } from "./commun.zod";

export const DroitBaseSchema = z.object({
  name: z.string().min(1, "Le nom est requis").max(255, "Le nom ne peut pas dépasser 255 caractères").nullable().optional(),
  is_init: z.boolean().default(false).optional(),
});

export const DroitSchema = DroitBaseSchema.extend({
  id: z.number().int().positive(),
  created_at: z.date().nullable().optional(),
  updated_at: z.date().nullable().optional(),
});

export const DroitCreateSchema = DroitBaseSchema.pick({
  name: true,
  is_init: true,
});

export const DroitUpdateSchema = z.object({
  id: z.number().int().positive(),
  name: z.string().min(1, "Le nom est requis").max(255, "Le nom ne peut pas dépasser 255 caractères").nullable().optional(),
  is_init: z.boolean().optional(),
});

export const DroitListResponseSchema = z.object({
  data: z.array(DroitSchema),
 meta : metaSchema
});

export const DroitResponseSchema = z.object({
  data: DroitSchema,
  message: z.string().optional(),
});

export const DroitSelectSchema = z.object({
  id: z.number().int().positive().optional(),
  name: z.string().optional(),
  is_init: z.boolean().optional(),
  limit: z.number().default(10),
  page: z.number().default(1),
  search: z.string().optional(),
  sortBy: sortBySchema
});

export type Droit = z.infer<typeof DroitSchema>;
export type DroitCreateInput = z.infer<typeof DroitCreateSchema>;
export type DroitUpdateInput = z.infer<typeof DroitUpdateSchema>;
export type DroitSelectInput = z.infer<typeof DroitSelectSchema>;

// Form-specific types for frontend
export type DroitFormData = Omit<DroitCreateInput, 'is_init'> & {
  is_init?: boolean;
};

export type DroitEditFormData = Omit<DroitUpdateInput, 'id'>;

// Utility types for different UI states
export type DroitDisplayItem = Pick<Droit, 'id' | 'name' | 'is_init'>;
export type DroitSelectOption = Pick<Droit, 'id' | 'name'>;
export type DroitTableItem = Pick<Droit, 'id' | 'name' | 'is_init' | 'created_at' | 'updated_at'>;

export type DroitResponse = z.infer<typeof DroitResponseSchema>;
export type DroitListResponse = z.infer<typeof DroitListResponseSchema>;

export const validateDroitCreate = (data: unknown) => {
  return DroitCreateSchema.safeParse(data);
};

export const validateDroitUpdate = (data: unknown) => {
  return DroitUpdateSchema.omit({ id: true }).safeParse(data);
};

export const validateDroitSelect = (data: unknown) => {
  return DroitSelectSchema.safeParse(data);
};
